import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  stroke: "transparent",
  viewBox: "0 0 220 522"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("symbol", {
      id: "petal",
      viewBox: "0 0 220 522"
    }, [
      _createElementVNode("path", {
        fill: "inherit",
        d: "M217.694 215c-9.976 116.083-108 307-108 307s-98.032-191.003-108-307c-11-128.003 32.337-215 108-215s119.099 85.854 108 215Z"
      })
    ], -1)
  ]))]))
}
export default { render: render }